/**
 * Returns the effective payment date as a local Date.
 *
 * For `paid_at` values that come from bulk imports stored as `YYYY-MM-DD 00:00:00+00`,
 * parsing them with `new Date(...)` shifts the day backwards in negative-UTC timezones
 * (e.g. Argentina UTC-3 turns `2026-05-01T00:00:00Z` into `Apr 30 21:00`).
 *
 * To avoid that, when `paid_at` is present we extract the calendar date (YYYY-MM-DD)
 * and build a local Date with those components, ignoring the UTC time part.
 *
 * Falls back to `created_at` (parsed normally, since it's a real timestamp) when
 * `paid_at` is missing.
 */
export const getPaymentDate = (payment: { paid_at?: string | null; created_at?: string | null }): Date => {
  const raw = payment.paid_at;
  if (raw) {
    const datePart = raw.split("T")[0]; // "2026-05-01"
    const [year, month, day] = datePart.split("-").map(Number);
    if (year && month && day) {
      return new Date(year, month - 1, day);
    }
  }
  return new Date(payment.created_at || Date.now());
};
